module.exports = __webpack_public_path__ + "./img-daisy_6626c970d8a6743430a4f3219cd44d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/img-daisy.png
// module id = 462
// module chunks = 0